<template>
  <div class="tiles__tile" :class="[`tiles__tile--${size}`]">
    <a :href="tile.url" class="tiles__inner">
      <Heart
        :id="tile.id"
        :absolute="true"
        :type="tile.type"
        :title="tile.title"
        :price="tile.price"
        :category="firtsCategory"
        :image="tile.image?.small?.default?.src ?? ''"
        :url="tile.url"
        :icon="tile.icon"
      />
      <Image :image="tile.image[size] ?? null"/>

      <div class="tiles__text-wrap">
        <div class="tiles__category" v-if="firtsCategory">
          <div class="tiles__category-icon" v-if="firtsCategory.lfmsite_icon">
            <i :class="firtsCategory.lfmsite_icon"></i>
          </div>
          <div class="tiles__category-label">
            {{ firtsCategory.title }}
          </div>
        </div>
        <div class="tiles__title-wrap">
          <div class="tiles__title">
            {{ tile.title }}
          </div>
        </div>
      </div>

    </a>
  </div>
</template>


<script setup>
import {computed} from 'vue'
import Image from "./Image.vue";
import Heart from "../../../Extensions/Components/Heart.vue";

const props = defineProps({
  tile: /** @type {RecordTile} */ Object,
  size: String,
  filters: Object,
})

const firtsCategory = computed(() => {
  const filteringIds = [
    ...props.filters.when,
    ...props.filters.who,
    ...props.filters.what,
  ].map(c => c.value);

  const candidates = [];
  if (props.tile.mainCategory) {
    candidates.push(props.tile.mainCategory);
  }
  if (props.tile.categories) {
    candidates.push(...props.tile.categories);
  }

  return candidates.find(c => filteringIds.includes(c.uid)) || candidates[0];
})

</script>
